import React from "react";
import Phone from "./Phone";

interface Props {
  keywords?: string;
  title: string;
  subTitle?: string;
  imgSrc: string;
  callToAction?: JSX.Element;
  deviceType: "ios" | "android" | "frame";
}

const Hero = ({
  keywords,
  title,
  subTitle,
  imgSrc,
  callToAction,
  deviceType,
}: Props) => {
  return (
    <div className="py-32">
      <div className="container flex flex-col flex-wrap items-center px-6 mx-auto md:flex-row">
        <div className="flex flex-col items-start justify-center w-full text-center md:w-1/2 lg:w-2/5 md:text-left">
          {keywords && (
            <p className="w-full uppercase tracking-loose">{keywords}</p>
          )}
          {title && (
            <h1 className="my-4 text-5xl font-bold leading-tight">{title}</h1>
          )}
          {subTitle && (
            <p className="mb-8 text-2xl leading-normal text-gray-800">
              {subTitle}
            </p>
          )}
          {callToAction}
        </div>

        <div className="items-center w-full py-6 text-center md:w-1/2 lg:w-3/5">
          {/*<img className="z-50 w-full m-auto md:w-3/5" src={imgSrc} alt="" />*/}
          <Phone deviceType={deviceType} imgSrc={imgSrc} />
        </div>
      </div>
    </div>
  );
};

export default Hero;
